import { gql } from "@apollo/client";

export default gql`
  mutation SubscribeForNewsletterFromStory($email: String!) {
    subscribeForNewsletterFromStory(email: $email)
  }
`;
